<h2 mat-dialog-title>Create Buyer Group</h2>
<mat-dialog-content>
  <p>{{ nonBuyersWarning.buyers.length }} {{ nonBuyersWarning.buyers.length === 1 ? 'buyer' : 'buyers' }} selected.</p>

  <tc-non-buyers-warning
    #nonBuyersWarning
    [selectedCompanies]="data.selectedCompanies"
    (buyersChange)="buyers = $event"
  ></tc-non-buyers-warning>

  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Group Name</mat-label>
    <input matInput [formControl]="nameCtrl" />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || nameCtrl.invalid || nonBuyersWarning.hasErrors || !buyers.length">Save</button>
</mat-dialog-actions>